import { API_CONFIG } from './apiConfig';

export const fetchRSSNews = async (lang: string | undefined) => {
  if (!lang) {
    lang = process.env.REACT_APP_DEFAULT_NEWS_LANGUAGE;
  }
  try {
    const urlToBeInvoked =
      lang === 'pl' ? API_CONFIG.RSS_PL_URL! : `${API_CONFIG.RSS_URL}/${lang}`;
    const response = await fetch(urlToBeInvoked);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching RSS news:', error);
    throw error;
  }
};
